module.exports = __webpack_public_path__ + "static/media/25PerformancePhotos.58ddbab2.jpeg";